<template>
  <div>
    <van-field
      v-model="val"
      type="textarea"
      :label="label"
      :placeholder="placeholder || label"
      :rows="rows" :maxlength="maxlength"
      :autosize="autosize" :show-word-limit="showWordLimit"
      :rules="rules"
      :readonly="readonly"
      :clearable="clearable"
      :required="required"
      @input="change"
    >
      <base-button v-if="showSelect" slot="button" @click="show = true">选择</base-button>
    </van-field>
    <van-action-sheet v-model="show" :actions="actions"
                      :title="'选择 ' + label" @select="select" />
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    value: {
      type: String,
      default: ''
    },
    labelAttr: {
      type: String,
      default: 'name'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    rules: {
      type: Array,
      default: function() {
        return [{ required: this.required, message: '请输入' + this.label }]
      }
    },
    maxlength: {
      type: Number,
      default: 100
    },
    autosize: {
      type: Boolean,
      default: true
    },
    showWordLimit: {
      type: Boolean,
      default: true
    },
    showSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      val: this.value,
      actions: this.options
    }
  },
  watch: {
    value: function(value) {
      this.val = value
    },
    options: function(options) {
      this.actions = options
    },
    val: function(value) {
      this.$emit('change', value)
    }
  },
  methods: {
    select(action) {
      this.val = action[this.labelAttr]
      this.$emit('change', this.val)
      this.show = false
    },
    change(value) {
      this.$emit('change', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseTextarea.vue